module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "downLoad mypage_icon",
    attrs: {
      "href": _vm.myPageLogTea,
      "target": "_blank"
    }
  }, [_vm._v("My Page")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-137be247"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/mypage.vue
// module id = 822
// module chunks = 1